export default "__VITE_ASSET__DsgTWr5c__"